<template>
  <navbar
    position="fixed"
    :transparent="transparent"
    :color-on-scroll="colorOnScroll"
    menu-classes="ml-auto"
  >
    <template slot-scope="{ toggle, isToggled }">
      <div v-popover:popover1 class="navbar-brand" @click="test">
        <img src="@/../public/img/happyfan7/logo.png" height="60px" />
      </div>
    </template>
  </navbar>
</template>

<script>
import { DropDown, NavbarToggleButton, Navbar, NavLink } from "@/components";
import { Popover } from "element-ui";
export default {
  name: "main-navbar",
  props: {
    transparent: Boolean,
    colorOnScroll: Number
  },
  components: {
    DropDown,
    Navbar,
    NavbarToggleButton,
    NavLink,
    [Popover.name]: Popover
  },
  methods: {
    test() {
      if (this.$route.path === "/ecommerce") this.$router.go();
      else this.$router.push({ path: "/ecommerce", query: this.$route.query });
    }
  }
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 600px) {
  .navbar-brand {
    padding: 15px 0px 8px 20px !important;
  }
}
</style>
